<template>
	<div>
		<div class="w-full">
			<GridLayout :sidebarState="sidebarState">
				<template #right-header>
					<Title :value="'ENCAIXE'" />
				</template>
				<template #right-content>
					<div
						class="w-full flex-1 main-content flex flex-col items-center px-4"
					>
						<transition
							name="fade"
							mode="out-in"
						>
							<div
								v-if="step === 'pre'"
								:key="step"
							></div>

							<Schedules
								v-if="step === 'schedules'"
								:key="step"
								class="w-full flex-1 flex flex-col py-4"
								type="fit"
								:modality_id="scheduling.modality_id"
								:proceedings="scheduling.proceedings"
								:schedules="scheduling.schedules"
								@next="WalkStep"
								@previous="DynamicPrevious"
							/>

							<AttendancePriority
								v-if="step === 'attendance_priority'"
								:key="step"
								class="w-full flex-1 flex flex-col py-4"
								ref="attendance_priority"
								:classification="scheduling.classification"
								@next="WalkStep"
								@previous="step = 'schedules'"
							/>

							<Confirm
								v-if="step === 'confirm'"
								:key="step"
								:class="!printStatement ? 'pb-3' : 'pb-1'"
								type="fit"
								:module_id="selected_module_id"
								:modality_id="scheduling.modality_id"
								:partnership="scheduling.partnership"
								:proceedings="scheduling.proceedings"
								:time="scheduling.time"
								:patient="scheduling.patient"
								:classification="scheduling.classification"
								:printStatement="printStatement"
								:indicator="scheduling.indicator"
								:origin="scheduling.origin"
								ref="confirm"
								@indicator="SetIndicator"
								@next="WalkStep"
								@previous="step = 'attendance_priority'"
							/>
						</transition>
					</div>
				</template>
				<template #right-footer>
					<div
						v-if="step !== 'pre'"
						class="w-full h-full flex justify-between items-center gap-3"
					>
						<button
							class="btn btn-light btn-fixed-size"
							type="button"
							@click="Previous"
						>
							VOLTAR
						</button>
						<button
							v-if="
								['attendance_priority', 'confirm'].includes(
									step
								)
							"
							:class="[
								'btn',
								'btn-fixed-size',
								step === 'confirm' ? 'btn-success' : '',
							]"
							type="button"
							@click="Continue"
						>
							{{ step === 'confirm' ? 'ENCAIXAR' : 'AVANÇAR' }}
						</button>
					</div>
				</template>
			</GridLayout>
		</div>
	</div>
</template>

<script>
	const _ = window._
	import moment from 'moment'

	import Patient from '@/components/shared/scheduling/Patient'
	import Schedules from '@/components/shared/scheduling/Schedules'
	import AttendancePriority from '@/components/shared/scheduling/AttendancePriority'
	import Confirm from '@/components/shared/scheduling/Confirm'

	import { mapGetters, mapActions } from 'vuex'
	import Swal from 'sweetalert2'
	export default {
		name: 'ReFitWizard',
		components: {
			Patient,
			Schedules,
			AttendancePriority,
			Confirm,
		},
		props: {
			scheduling_id: {
				type: [String, Number],
				default: null,
			},
			source: {
				type: String,
				default: null,
			},
		},
		data() {
			return {
				step: 'pre',
				source_page: this.source,
				scheduling: {
					module_id: null,
					modality_id: null,
					schedules: [],
					proceedings: [],
					partnership: null,
					billing: null,
					place: null,
					time: null,
					patient: null,
					classification: 1,
					obs: '',
					indicator: null,
					payment_info: null,
					origin: 4, // ORIGIN_FIT
				},
				base_proceedings: [],
				printStatement: false,
				sidebarState: false,
			}
		},
		computed: {
			...mapGetters('auth', ['requester_selected_id']),
			...mapGetters('system', ['modules']),
			selected_module_id() {
				const module = this.modules.find(
					m => m.name === this.scheduling.module
				)

				return module.id
			},
		},
		watch: {
			step: {
				handler(val) {
					let hash = ''

					switch (val) {
						case 'schedules':
							hash = '#horarios'
							break
						case 'attendance_priority':
							hash = '#prioridade-de-atendimento'
							break
						case 'patient':
							hash = '#paciente'
							break
						case 'confirm':
							hash = '#confirmacao'
							break
					}

					window.location.hash = hash
				},
				immediate: true,
			},
			$route(to) {
				switch (to.hash) {
					case '#horarios':
						this.step = 'schedules'
						break
					case '#paciente':
						this.step = 'patient'
						break
					case '#prioridade-de-atendimento':
						this.step = 'attendance_priority'
						break
					case '#confirmacao':
						this.step = 'confirm'
						break
				}
			},
		},
		methods: {
			...mapActions('system', [
				'StartLoading',
				'FinishLoading',
				'GetModulesAndModalities',
			]),
			Previous() {
				switch (this.step) {
					case 'attendance_priority':
						this.step = 'schedules'
						break
					case 'confirm':
						this.step = 'attendance_priority'
						break
					case 'schedules':
						window.history.go(-2)
						break
				}
			},
			DynamicPrevious() {
				if (this.step == 'schedules') {
					window.history.go(-2)
				}
			},
			Continue() {
				const refMap = {
					attendance_priority: 'attendance_priority',
					confirm: 'confirm',
				}

				const ref = refMap[this.step]

				if (ref && this.$refs[ref]?.Continue) {
					this.$refs[ref].Continue()
				}
			},
			async WalkStep(param = null) {
				const vm = this
				const day_of_week = new Date().getDay()

				switch (this.step) {
					case 'pre':
						this.step = 'schedules'

						this.scheduling.schedules = _.orderBy(
							_.filter(this.scheduling.schedules, schedule => {
								let dias_habilitados = JSON.parse(
									schedule.dias_habilitados
								)

								let allowed = false

								if (dias_habilitados) {
									if (schedule.ciclica) {
										allowed = dias_habilitados.find(
											dia =>
												dia.value == day_of_week &&
												dia.selected
										)

										allowed = typeof allowed === 'object'
									} else {
										let today = new Date()
										today = `${today
											.getDate()
											.toString()
											.padStart(2, '0')}/${(
											today.getMonth() + 1
										)
											.toString()
											.padStart(
												2,
												'0'
											)}/${today.getFullYear()}`

										allowed =
											_.findIndex(dias_habilitados, {
												fulldate: today,
											}) > -1
									}
								}

								return (
									!schedule.continua &&
									schedule.status &&
									allowed
								)
							}),
							'nome'
						)

						if (this.scheduling.schedules.length > 0) {
							this.step = 'schedules'
						} else {
							Swal.fire({
								title: 'Eita!',
								text: 'Não há agendas disponiveis para hoje.',
								icon: 'error',
							})
						}

						break
					case 'schedules':
						this.scheduling.time = param
						this.scheduling.time.dia = moment().format('YYYY-MM-DD')
						this.scheduling.time.hora = moment().format('HH:mm:ss')
						this.scheduling.classification = 1
						this.scheduling.obs = ''
						this.scheduling.place = null

						this.scheduling.origin = this.GetAttendanceOrigin()

						this.step = 'attendance_priority'
						break
					case 'attendance_priority':
						this.scheduling.classification = param.classification
						this.scheduling.obs = ''
						this.scheduling.place = null

						this.step = 'confirm'

						break
					case 'confirm':
						this.scheduling.obs = param.obs
						this.scheduling.place = param.place

						await this.SaveFitNoShow()

						break
				}
			},
			GetProceedingsDetails() {
				this.StartLoading()

				return window.api
					.call('post', '/get-proceeding-details', {
						account_id: this.requester_selected_id,
						modality_id: this.scheduling.modality_id,
						proceeding_id: this.scheduling.proceeding.id,
						partnership_id: this.scheduling.partnership.id,
					})
					.then(({ data }) => {
						if (data.response) {
							this.base_proceedings = data.partnership.proceedings
							this.scheduling.schedules = data.schedules
						}
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
			async GetSchedulingData() {
				const vm = this

				vm.StartLoading()

				return await window.api
					.call('post', '/get-scheduling-data', {
						account_id: vm.requester_selected_id,
						scheduling: vm.scheduling_id,
					})
					.then(async ({ data }) => {
						if (data.response) {
							const scheduling = data.scheduling

							vm.scheduling = { ...scheduling }
							vm.scheduling.patient = scheduling.journey.patient
							vm.scheduling.partnership =
								scheduling.partnerships[0]

							const override = vm._scheduling_data

							if (override) {
								if (override.billing)
									vm.scheduling.billing = override.billing
								if (override.partnership)
									vm.scheduling.partnership =
										override.partnership
								if (override.indicator)
									vm.scheduling.indicator = override.indicator
							}

							await vm.GetProceedingsDetails()

							let arr = []

							vm.base_proceedings.forEach(p => {
								if (p.id === vm.scheduling.proceeding.id) {
									arr.push(p)
								}
							})

							vm.scheduling.proceedings = arr
						}
					})
					.finally(() => {
						vm.FinishLoading()
					})
			},
			GetAttendanceOrigin() {
				const ORIGIN_FIT = 4

				let origin = ORIGIN_FIT

				return origin
			},
			SaveFitNoShow() {
				const vm = this

				vm.StartLoading()

				delete vm.scheduling.schedules

				return window.api
					.call('post', '/save-fit-no-show', {
						scheduling_id: vm.scheduling.id,
						account_id: vm.requester_selected_id,
						origin: 2, // ORIGIN_SCHEDULING_PRE_APPOINTMENT
						...vm.scheduling,
					})
					.then(({ data }) => {
						if (data.response) {
							vm.scheduling.journey_id = data.journey
							vm.printStatement = true

							Swal.fire({
								icon: 'question',
								title: 'Deseja imprimir o dados do encaixe ?',
								showConfirmButton: true,
								showCancelButton: true,
								confirmButtonText: 'Sim',
								cancelButtonText: 'Não',
								width: 'auto',
								customClass: {
									confirmButton: 'success',
								},
							}).then(async res => {
								if (res.isConfirmed) {
									vm.PrintTimeline()
								}

								vm.printStatement = false

								await Swal.fire({
									title: 'Concluido !',
									html: `Paciente encaixado com sucesso.<br>ID: ${data.journey}`,
									icon: 'success',
								})

								if (vm.source_page) {
									vm.$router.push({ name: vm.source_page })
								} else {
									vm.$router.push({ name: 'ConfirmWizard' })
								}
							})
						} else {
							Swal.fire({
								icon: 'error',
								title: 'Opss...',
								text: 'Houve um erro ao concluir, contate o suporte.',
							})
						}
					})
					.finally(() => {
						vm.FinishLoading()
					})
			},
			PrintTimeline() {
				const vm = this

				const fn = event => {
					if (event.data.print) {
						window.removeEventListener('message', fn)

						win.close()
					}
				}

				const win = window.open(
					`/pesquisa/imprimir?journey_id=${vm.scheduling.journey_id}`,
					'_blank'
				)
				win.mainWindow = window
				window.addEventListener('message', fn)
			},
			SetIndicator(indicator) {
				this.scheduling.indicator = indicator
			},
			CancelScheduling() {
				const vm = this

				vm.StartLoading()

				let arr = []

				arr.push({ id: vm.scheduling.id })

				return window.api
					.call('post', '/cancel-schedulings', {
						schedulings: arr,
						organization_id: vm.requester_selected_id,
					})
					.then(({ data }) => {
						if (data.response) {
							vm.step = 'pre'

							return data
						} else {
							window.helpers.errorMessageTop(
								'Houve um erro ao excluir o agendamento anterior, contate o suporte.',
								4000
							)
						}
					})
					.finally(() => {
						vm.dialog = false

						vm.FinishLoading()
					})
			},
		},
		async beforeMount() {
			this._scheduling_data = this.$route.query.scheduling_data
				? JSON.parse(this.$route.query.scheduling_data)
				: null

			await this.GetModulesAndModalities()

			await this.GetSchedulingData()

			this.WalkStep()
		},
	}
</script>

<style lang="css" scoped></style>
